import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_WEALTH_PROGRAM_LIST = 'WEALTH/FETCH_WEALTH_PROGRAM_LIST';

const apiCall = createApiCall(
  FETCH_WEALTH_PROGRAM_LIST,
  (params: Record<string, any>) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/wealth/programs`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
